import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TemplateRequest } from '@core/models';
import { Observable, of } from 'rxjs';
import SYSTEXT_MODELS from '../../../resources/systemText-english.json';
import { ConstantsService } from './constants.service';
import { NotificationService } from './notification.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class SysTextService {
  // #region Constructors (1)

  constructor(
    private constants: ConstantsService, 
    private http: HttpClient,
    private notificationService: NotificationService,
    private cookieService: CookieService
  ) {}

  // #endregion Constructors (1)

  // #region Public Methods (1)

  public getSysText(template: string | object): Observable<any> {
    const tempReq: TemplateRequest = this.makeTemplateRequestDTO(template);

    var sysText$ = this.http.post(`${this.constants.LANGUAGE_API}/GetTemplateSystemText/`, tempReq);

    sysText$.subscribe({
      next: (data) => {
        var sysText = data;
        
        if (sysText["systemMessage"] != null) {
          this.handleSystemMessage(
            sysText["systemMessage"]["systemMessageTitle"],
            sysText["systemMessage"]["systemMessageBody"],
            sysText["systemMessage"]["systemMessageKey"]);
        }
        else if (sysText["systemMessageTitle"] != null) {
          this.handleSystemMessage(
            sysText["systemMessageTitle"],
            sysText["systemMessageBody"],
            sysText["systemMessageKey"]);
        }
      }});

    return sysText$;

    // if (tempReq.names.length > 1) {
    //   const sysTextModels = {};
    //   tempReq.names.forEach((n) => {
    //     sysTextModels[n] = SYSTEXT_MODELS.templates[n];
    //   });
    //   return of(sysTextModels);
    // } else {
    //   return of(SYSTEXT_MODELS.templates[tempReq.names[0]]);
    // }
  }

  private handleSystemMessage(title: string, body: string, key: string)
  {
    if (this.cookieService.get(key)?.length == 0) {
      const expiresDate: Date = new Date();
        expiresDate.setDate(expiresDate.getDate() + 1);
        this.cookieService.set(key, "shown", { expires: expiresDate, path: "/" });

      // stays until closed (ngx-sonner treats a duration of 0 as "close now", so it used to vanish at once)
      this.notificationService.showInfoToast(title, body, Infinity);
      }
  }

  // #endregion Public Methods (1)

  // #region Private Methods (3)

  private isObject(obj: any): boolean {
    return obj === Object(obj);
  }

  private makeTemplateNameArray(templateObj: object): string[] {
    return Object.keys(templateObj).map((itm) => templateObj[itm]);
  }

  private makeTemplateRequestDTO(template: string | object): TemplateRequest {
    const tReq: TemplateRequest = {
      languageCode: 'en',
      names: [],
    };

    if (!this.isObject(template)) {
      tReq.names.push(template as string);
    } else {
      tReq.names = this.makeTemplateNameArray(template as object);
    }
    return { ...tReq };
  }

  // #endregion Private Methods (3)
}
